export const locales: Record<string, () => Promise<unknown>> = {
  af: () => import('dayjs/locale/af'),
  am: () => import('dayjs/locale/am'),
  'ar-DZ': () => import('dayjs/locale/ar-dz'),
  'ar-IQ': () => import('dayjs/locale/ar-iq'),
  'ar-KW': () => import('dayjs/locale/ar-kw'),
  'ar-LY': () => import('dayjs/locale/ar-ly'),
  'ar-MA': () => import('dayjs/locale/ar-ma'),
  'ar-SA': () => import('dayjs/locale/ar-sa'),
  'ar-TN': () => import('dayjs/locale/ar-tn'),
  ar: () => import('dayjs/locale/ar'),
  az: () => import('dayjs/locale/az'),
  be: () => import('dayjs/locale/be'),
  bg: () => import('dayjs/locale/bg'),
  bi: () => import('dayjs/locale/bi'),
  bm: () => import('dayjs/locale/bm'),
  'bn-BD': () => import('dayjs/locale/bn-bd'),
  bn: () => import('dayjs/locale/bn'),
  bo: () => import('dayjs/locale/bo'),
  br: () => import('dayjs/locale/br'),
  ca: () => import('dayjs/locale/ca'),
  bs: () => import('dayjs/locale/bs'),
  cs: () => import('dayjs/locale/cs'),
  cv: () => import('dayjs/locale/cv'),
  cy: () => import('dayjs/locale/cy'),
  da: () => import('dayjs/locale/da'),
  'de-AT': () => import('dayjs/locale/de-at'),
  'de-CH': () => import('dayjs/locale/de-ch'),
  de: () => import('dayjs/locale/de'),
  dv: () => import('dayjs/locale/dv'),
  el: () => import('dayjs/locale/el'),
  'en-AU': () => import('dayjs/locale/en-au'),
  'en-CA': () => import('dayjs/locale/en-ca'),
  'en-GB': () => import('dayjs/locale/en-gb'),
  'en-IE': () => import('dayjs/locale/en-ie'),
  'en-IL': () => import('dayjs/locale/en-il'),
  'en-IN': () => import('dayjs/locale/en-in'),
  'en-NZ': () => import('dayjs/locale/en-nz'),
  'en-SG': () => import('dayjs/locale/en-sg'),
  'en-TT': () => import('dayjs/locale/en-tt'),
  en: () => import('dayjs/locale/en'),
  eo: () => import('dayjs/locale/eo'),
  'es-PR': () => import('dayjs/locale/es-pr'),
  'es-MX': () => import('dayjs/locale/es-mx'),
  'es-DO': () => import('dayjs/locale/es-do'),
  'es-US': () => import('dayjs/locale/es-us'),
  es: () => import('dayjs/locale/es'),
  et: () => import('dayjs/locale/et'),
  eu: () => import('dayjs/locale/eu'),
  fa: () => import('dayjs/locale/fa'),
  fi: () => import('dayjs/locale/fi'),
  fo: () => import('dayjs/locale/fo'),
  'fr-CA': () => import('dayjs/locale/fr-ca'),
  'fr-CH': () => import('dayjs/locale/fr-ch'),
  fr: () => import('dayjs/locale/fr'),
  fy: () => import('dayjs/locale/fy'),
  ga: () => import('dayjs/locale/ga'),
  gd: () => import('dayjs/locale/gd'),
  gl: () => import('dayjs/locale/gl'),
  'gom-LATN': () => import('dayjs/locale/gom-latn'),
  gu: () => import('dayjs/locale/gu'),
  he: () => import('dayjs/locale/he'),
  hi: () => import('dayjs/locale/hi'),
  hr: () => import('dayjs/locale/hr'),
  ht: () => import('dayjs/locale/ht'),
  hu: () => import('dayjs/locale/hu'),
  'hy-AM': () => import('dayjs/locale/hy-am'),
  id: () => import('dayjs/locale/id'),
  is: () => import('dayjs/locale/is'),
  'it-CH': () => import('dayjs/locale/it-ch'),
  it: () => import('dayjs/locale/it'),
  ja: () => import('dayjs/locale/ja'),
  jv: () => import('dayjs/locale/jv'),
  ka: () => import('dayjs/locale/ka'),
  kk: () => import('dayjs/locale/kk'),
  km: () => import('dayjs/locale/km'),
  kn: () => import('dayjs/locale/kn'),
  ko: () => import('dayjs/locale/ko'),
  ku: () => import('dayjs/locale/ku'),
  lb: () => import('dayjs/locale/lb'),
  ky: () => import('dayjs/locale/ky'),
  lo: () => import('dayjs/locale/lo'),
  lt: () => import('dayjs/locale/lt'),
  lv: () => import('dayjs/locale/lv'),
  me: () => import('dayjs/locale/me'),
  mi: () => import('dayjs/locale/mi'),
  mk: () => import('dayjs/locale/mk'),
  ml: () => import('dayjs/locale/ml'),
  mn: () => import('dayjs/locale/mn'),
  mr: () => import('dayjs/locale/mr'),
  'ms-MY': () => import('dayjs/locale/ms-my'),
  ms: () => import('dayjs/locale/ms'),
  mt: () => import('dayjs/locale/mt'),
  my: () => import('dayjs/locale/my'),
  nb: () => import('dayjs/locale/nb'),
  ne: () => import('dayjs/locale/ne'),
  'nl-BE': () => import('dayjs/locale/nl-be'),
  nl: () => import('dayjs/locale/nl'),
  nn: () => import('dayjs/locale/nn'),
  'oc-LNC': () => import('dayjs/locale/oc-lnc'),
  'pa-IN': () => import('dayjs/locale/pa-in'),
  pl: () => import('dayjs/locale/pl'),
  'pt-BR': () => import('dayjs/locale/pt-br'),
  pt: () => import('dayjs/locale/pt'),
  rn: () => import('dayjs/locale/rn'),
  ro: () => import('dayjs/locale/ro'),
  ru: () => import('dayjs/locale/ru'),
  rw: () => import('dayjs/locale/rw'),
  sd: () => import('dayjs/locale/sd'),
  se: () => import('dayjs/locale/se'),
  si: () => import('dayjs/locale/si'),
  sk: () => import('dayjs/locale/sk'),
  sl: () => import('dayjs/locale/sl'),
  sq: () => import('dayjs/locale/sq'),
  'sr-CYRL': () => import('dayjs/locale/sr-cyrl'),
  sr: () => import('dayjs/locale/sr'),
  ss: () => import('dayjs/locale/ss'),
  'sv-FI': () => import('dayjs/locale/sv-fi'),
  sv: () => import('dayjs/locale/sv'),
  sw: () => import('dayjs/locale/sw'),
  ta: () => import('dayjs/locale/ta'),
  te: () => import('dayjs/locale/te'),
  tet: () => import('dayjs/locale/tet'),
  tg: () => import('dayjs/locale/tg'),
  th: () => import('dayjs/locale/th'),
  tk: () => import('dayjs/locale/tk'),
  'tl-PH': () => import('dayjs/locale/tl-ph'),
  tlh: () => import('dayjs/locale/tlh'),
  tr: () => import('dayjs/locale/tr'),
  tzl: () => import('dayjs/locale/tzl'),
  'tzm-LATN': () => import('dayjs/locale/tzm-latn'),
  tzm: () => import('dayjs/locale/tzm'),
  'ug-CN': () => import('dayjs/locale/ug-cn'),
  uk: () => import('dayjs/locale/uk'),
  ur: () => import('dayjs/locale/ur'),
  'uz-LATN': () => import('dayjs/locale/uz-latn'),
  uz: () => import('dayjs/locale/uz'),
  vi: () => import('dayjs/locale/vi'),
  'x-PSEUDO': () => import('dayjs/locale/x-pseudo'),
  yo: () => import('dayjs/locale/yo'),
  'zh-CN': () => import('dayjs/locale/zh-cn'),
  'zh-HK': () => import('dayjs/locale/zh-hk'),
  'zh-TW': () => import('dayjs/locale/zh-tw'),
  zh: () => import('dayjs/locale/zh'),
};
